<div class="row">
  <!-- Chart -->
  <div class="col-12 col-xl-9 order-last order-xl-first px-4">
    <ng-container *ngTemplateOutlet="chart"></ng-container>
  </div>
  <div class="col-12 col-xl-3 order-first order-xl-last ps-xl-2 pb-5 pb-xl-0 filter">
    <!-- Filter -->
    <ts-filter filterId="filterCharts"
               [filters]="filters">
    </ts-filter>
  </div>
</div>

<ng-template #chart>
  <h4 class="d-inline-block" i18n="@@Page.Chart.Customers.Title">
    [i18n] Planned/actual by customer
  </h4>
  <div class="row">
    <div class="col-md-3 d-none d-md-inline">
      <ts-chart-workday-info
        type="customer"
        [overbookEntries]="overbookedCustomers"
        [daysPlanned]="tableFooter.daysPlanned"
        [daysWorked]="tableFooter.daysWorked"
        [daysDifference]="tableFooter.daysDifference">
      </ts-chart-workday-info>
    </div>
    <div class="col-md-9">
      <div id="chart" *ngIf="chartSeries">
        <apx-chart
          [series]="chartSeries"
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xAxis"
          [yaxis]="chartOptions.yAxis"
          [colors]="chartOptions.colors"
          [plotOptions]="chartOptions.plotOptions"
          [fill]="chartOptions.fill"
          [grid]="chartOptions.grid"
          [states]="chartOptions.states"
          [dataLabels]="chartOptions.dataLabels"
          [tooltip]="chartOptions.tooltip"
          [legend]="chartOptions.legend">
        </apx-chart>
      </div>
    </div>
  </div>

  <ts-chart-totals-overview
    class="d-none d-md-inline"
    [rows]="chartRows"
    [selectedRow]="chartRowsSelected">
  </ts-chart-totals-overview>

  <ts-simple-table
    class="d-block mt-5"
    [columns]="tableColumns"
    [rows]="tableRows"
    [configuration]="tableConfiguration"
    (rowsChanged)="tableRowsChanged($event.rows)"
    (dataCellClick)="dataCellClick($event)">
  </ts-simple-table>

  <div *ngIf="plannedArePartial" class="row">
    <div class="col p-0">
      <div class="alert alert-warning m-2" role="alert">
        <svg class="bi me-2" fill="currentColor">
          <use xlink:href="assets/icons.svg#calendar-range"/>
        </svg>
        <ng-container i18n="@@Page.Chart.Common.PartialPlannedValues">
          [i18n] The order period is greater than selected period. The values are displayed proportionally.
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customerDataTemplate let-row="row">
  <span class="chart-legend me-2" [ngStyle]="{'background-color': row.color}"></span>
  <span *ngIf="row.selected" class="text-primary me-2">
    <svg class="bi" fill="currentColor">
      <use xlink:href="assets/icons.svg#pin-angle-fill"/>
    </svg>
  </span>
  <span class="customer-title">{{row.customerTitle}}</span>
</ng-template>

<ng-template #orderPeriodHeadTemplate let-table="table" let-column="column">
  <span class="d-none d-lg-inline">{{column.title}}</span>
  <span class="d-none d-lg-inline" [class]="table.getCssSortOrder(column)">{{table.getGlyphSortOrder(column)}}</span>
</ng-template>

<ng-template #orderPeriodDataTemplate let-row="row">
  <div class="d-none d-lg-inline text-nowrap">
    {{formatService.formatDate(row.plannedStart)}} -
    <br class="d-inline d-xl-none">
    {{formatService.formatDate(row.plannedEnd)}}
    <svg *ngIf="row.plannedIsPartial" class="bi text-warning ms-2" fill="currentColor">
      <use xlink:href="assets/icons.svg#calendar-range"/>
    </svg>
  </div>
</ng-template>

<ng-template #daysDifferenceTemplate let-row="row">
  <svg *ngIf="row.daysDifference < 0" class="bi text-warning me-2" fill="currentColor">
    <use xlink:href="assets/icons.svg#exclamation-diamond-fill"/>
  </svg>
  <span *ngIf="row.daysPlanned">{{formatService.formatDays(row.daysDifference)}} {{LOCALIZED_DAYS}}</span>
  <span *ngIf="row.daysPlanned" class="percentage"> {{row.daysDifference > 0 ? formatService.formatRatio(row.daysDifference / row.daysPlanned) : '0'}} {{LOCALIZED_PERCENTAGE}}</span>
</ng-template>

<ng-template #orderPeriodFooterTemplate>
  <span class="d-none d-lg-inline">{{getMinPlanned()}} - {{getMaxPlanned()}}</span>
</ng-template>

<ng-template #infoCellTemplate let-row="row">
  <a class="text-secondary ms-2"
     [ngbPopover]="infoDetailPopover"
     [autoClose]="'outside'"
     popoverClass="popup-full-width">
    <svg class="bi action-icon" fill="currentColor">
      <use xlink:href="assets/icons.svg#info-circle"/>
    </svg>
  </a>

  <ng-template #infoDetailPopover>
    <table class="table table-borderless table-popover">
      <tbody>
      <tr>
        <th colspan="3" class="pt-1" i18n="@@Page.Chart.Common.Worked">[i18n] Worked</th>
      </tr>
      <tr>
        <td>{{formatService.formatDays(row.daysWorked)}} {{LOCALIZED_DAYS}}</td>
        <td>{{row.timeWorked | tsDuration}}</td>
        <td>{{formatService.formatBudget(row.budgetWorked)}} {{row.currency}}</td>
      </tr>
      <tr *ngIf="row.daysPlanned > 0">
        <th colspan="3" i18n="@@Page.Chart.Common.Planned">[i18n] Planned</th>
      </tr>
      <tr *ngIf="row.daysPlanned > 0">
        <td>{{formatService.formatDays(row.daysPlanned)}} {{LOCALIZED_DAYS}}</td>
        <td>{{row.timePlanned | tsDuration}}</td>
        <td>{{formatService.formatBudget(row.budgetPlanned)}} {{row.currency}}</td>
      </tr>
      <tr *ngIf="row.daysPlanned > 0">
        <th *ngIf="row.daysDifference >= 0" colspan="3" class="pt-1" i18n="@@Page.Chart.Common.Left">[i18n] Left</th>
        <th *ngIf="row.daysDifference < 0" colspan="3" class="pt-1 overbooked" i18n="@@Page.Chart.Common.OverbookedBy">[i18n] Overbooked by</th>
      </tr>
      <tr *ngIf="row.daysPlanned > 0 && row.daysDifference >= 0">
        <td>{{formatService.formatDays(row.daysDifference)}} {{LOCALIZED_DAYS}}</td>
        <td>{{row.timeDifference | tsDuration}}</td>
        <td>{{formatService.formatBudget(row.budgetDifference)}} {{row.currency}}</td>
      </tr>
      <tr *ngIf="row.daysPlanned > 0 && row.daysDifference < 0" class="overbooked">
        <td>{{formatService.formatDays(row.daysDifference * -1)}} {{LOCALIZED_DAYS}}</td>
        <td>{{row.timeDifference.negate() | tsDuration}}</td>
        <td>{{formatService.formatBudget(row.budgetDifference * -1)}} {{row.currency}}</td>
      </tr>
      </tbody>
    </table>
  </ng-template>
</ng-template>

<ng-template #infoFooterTemplate>
  <ng-container *ngTemplateOutlet="infoCellTemplate; context: {row: tableFooter}"></ng-container>
</ng-template>
